import {openDb} from "../../../Services/BrowserDatabaseIDB";
import {ensureStoresExist, mergeChanged} from "../../../Services/BrowserDatabaseFunctions";

export function addEventTodo(_event_id, _to_do) {
    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite");
            const dataStore = tx.objectStore("Events");

            // Get the specific event by its id
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                // ensure to_do is an array
                const to_dos = Array.isArray(event.to_do)
                    ? event.to_do.slice()
                    : [];

                // prefer matching by id
                const idx = to_dos.findIndex(m =>
                    m &&
                    _to_do &&
                    m.id != null &&
                    _to_do.id != null &&
                    String(m.id) === String(_to_do.id)
                );

                if (idx >= 0) {
                    // update existing to_do; merge only defined fields
                    const base = to_dos[idx];
                    const patch = _to_do;
                    const merged = { ...base };
                    Object.keys(patch).forEach(k => {
                        if (typeof patch[k] !== "undefined") merged[k] = patch[k];
                    });
                    to_dos[idx] = merged;
                } else {
                    // add new to_do
                    to_dos.push(_to_do);
                }

                // write back
                event.to_do = to_dos;

                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                return dataStore.put(sanitizedEvent).then(() => {
                    console.log(
                        `To_do with ID ${_to_do.id} in Event with ID ${_event_id} added/updated successfully.`
                    );
                    return true;
                });
            });
        })
        .catch(function (error) {
            console.error("An error occurred in addEventTodo:", error);
            throw error;
        });
}

export function updateEventTodo(_event_id, _to_do) {
    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite");
            const dataStore = tx.objectStore("Events");

            // Get the specific event by its id
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                // ensure to_do is an array
                const to_dos = Array.isArray(event.to_do)
                    ? event.to_do.slice()
                    : [];

                // prefer matching by id
                const idx = to_dos.findIndex(m =>
                    m &&
                    _to_do &&
                    m.id != null &&
                    _to_do.id != null &&
                    String(m.id) === String(_to_do.id)
                );

                if (idx >= 0) {
                    const { merged, changed } = mergeChanged(to_dos[idx], _to_do);
                    if (changed) to_dos[idx] = merged;
                } else {
                    // add new to_do if not found
                    to_dos.push(_to_do);
                }

                // write back
                event.to_do = to_dos;

                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                return dataStore.put(sanitizedEvent).then(() => {
                    console.log(
                        `To_do with ID ${_to_do.id} in Event with ID ${_event_id} added/updated successfully.`
                    );
                    return true;
                });
            });
        })
        .catch(function (error) {
            console.error("An error occurred in updateEventTodo:", error);
            throw error;
        });
}

export function deleteEventTodo(_event_id, _to_do_id) {
    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite"); // Use 'readwrite' mode for updates
            const dataStore = tx.objectStore("Events");

            // Get the specific event by its id
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                const to_dos = Array.isArray(event.to_do)
                    ? event.to_do
                    : [];

                // Filter out the to_do with the specified ID
                const updatedToDos = to_dos.filter(to_do => {
                    if (!to_do) return false;
                    return String(to_do.id) !== String(_to_do_id);
                });

                // Update the event with the modified to_dos array
                event.to_do = updatedToDos;

                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                // Put the updated event back into the object store
                return dataStore.put(sanitizedEvent).then(() => {
                    console.log(
                        `To_do with ID ${_to_do_id} in Event with ID ${_event_id} deleted successfully.`
                    );
                    return true;
                });
            });
        })
        .catch(function (error) {
            console.error("An error occurred in deleteEventTodo:", error);
            throw error; // Re-throw the error to be caught by the caller
        });
}
